module.exports = __webpack_public_path__ + "static/media/seat.c03ad88e.svg";